import { render, staticRenderFns } from "./_videoList.vue?vue&type=template&id=85cf33d4&scoped=true"
import script from "./_videoList.vue?vue&type=script&lang=js"
export * from "./_videoList.vue?vue&type=script&lang=js"
import style0 from "./_videoList.vue?vue&type=style&index=0&id=85cf33d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85cf33d4",
  null
  
)

export default component.exports